import React from "react";
import { HiX } from "react-icons/hi";
import Modal from "react-modal";

Modal.setAppElement("#root");

type PROPS = {
  modalIsOpen: boolean;
  title: string;
  children: React.ReactNode;
  close: () => void;
};

const DialogBase: React.FC<PROPS> = (props) => {
  const modalStyle: Modal.Styles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0.60)",
      zIndex: 100,
    },
    content: {
      right: "unset",
      bottom: "unset",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      minWidth: "400px",
      maxWidth: "95vw",
      maxHeight: "95vh",
    },
  };

  const close = () => {
    props.close();
  };

  return (
    <Modal isOpen={props.modalIsOpen} onRequestClose={close} style={modalStyle}>
      <div className="flex justify-between items-center gap-4">
        <div className="font-bold text-xl">{props.title}</div>
        <div
          className="p-1 rounded cursor-pointer hover:bg-gray-300"
          onClick={close}
        >
          <HiX />
        </div>
      </div>
      {props.children}
    </Modal>
  );
};

export default DialogBase;
